export const ISalesTax = {
  id: 2,
  name: 'Tax 2',
  rate: '28.50',
  rate_type: 0,
  auto_apply: true,
  is_archive: false,
  last_user_id: 32,
  created_at: '2023-10-10T10:26:50.300Z',
  updated_at: '2023-10-10T10:26:50.300Z',
  archived_at: null,
}
